import type { IconProps } from "./icon-types";

/**
 * 전체 화면(screen full / maximize). 네 모서리 브라켓으로 확대/전체화면 전환 버튼 등에서 사용.
 * frame viewport 표식(타임라인 마커 기본 아이콘)도 겸한다 — 같은 브래킷 실루엣이라
 * 별도 FrameIcon을 두지 않고 이 글리프로 수렴.
 *
 * VS Code의 `VscScreenFull`(가운데 모니터 프레임 + 모서리 브라켓)은 c6 톤에 비해 무거워,
 * 클래식 fullscreen 브라켓만 있는 `react-icons/lu`의 `LuMaximize`(Lucide `maximize`)로 인라인 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 아이콘(Settings/Camera 등)과 톤·크기를 맞추기 위해 24 그리드 / stroke 기반 사용.
 */
export const ScreenFullIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 3H5a2 2 0 0 0-2 2v3" />
    <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
    <path d="M3 16v3a2 2 0 0 0 2 2h3" />
    <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
  </svg>
);
